import { render, staticRenderFns } from "./WindSpeedLastHourCard.vue?vue&type=template&id=b7a53d5c&"
import script from "./WindSpeedLastHourCard.vue?vue&type=script&lang=js&"
export * from "./WindSpeedLastHourCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports